import { createSlice } from '@reduxjs/toolkit';

export const servicesIaCreditTransactionsSlice = createSlice({
  name: 'servicesIaCreditTransactions',
  initialState: {
    transaction_list: [],
    transaction: null,
  },
  reducers: {
    setServicesIaCreditTransactionsListRedux: (state, { payload }) => {
      state.transaction_list = payload;
    },
    setServicesIaCreditTransactionActiveRedux: (state, { payload }) => {
      state.transaction = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setServicesIaCreditTransactionsListRedux,
  setServicesIaCreditTransactionActiveRedux,
} = servicesIaCreditTransactionsSlice.actions;
